import React, { useRef, useEffect } from 'react';
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import './plaza.scss';
import { PropTypes } from 'prop-types';
const _marks = {
  '0': '31',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  '10': '10'
};
const _marksReal = {
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  '10': '10'
};
const _marksDate = {
  '0': new Date('10/31/2019'),
  '1': new Date('11/1/2019'),
  '2': new Date('11/2/2019'),
  '3': new Date('11/3/2019'),
  '4': new Date('11/4/2019'),
  '5': new Date('11/5/2019'),
  '6': new Date('11/6/2019'),
  '7': new Date('11/7/2019'),
  '8': new Date('11/8/2019'),
  '9': new Date('11/9/2019'),
  '10': new Date('11/10/2019')
};
const getMin = () => {
  const today = new Date();
  const day = today.getDate();
  return day === 31 ? 0 : 1;
};

const getMax = () => {
  const today = new Date();
  const day = today.getDate();
  return day === 31 ? 0 : day > 10 ? 10 : day;
};

const getMarks = () => {
  const today = new Date();
  const day = today.getDate();
  return day === 31 ? _marks : _marksReal;
};

const PlazaRange = ({ onChange }) => {
  const min = getMin();
  const max = getMax();
  const marks = getMarks();

  useEffect(() => {
    onChange([_marksDate[min], _marksDate[max]]);
  }, []);

  const rangeEl = useRef(null);
  const validateChange = range => {
    if (range[1] > max) {
      rangeEl.current.onChange({
        handle: 1,
        bounds: [range[0], max]
      });
      onChange([_marksDate[range[0]], _marksDate[range[max]]]);
    }
    onChange([_marksDate[range[0]], _marksDate[range[1]]]);
  };
  return (
    <Range
      min={min}
      max={10}
      marks={marks}
      defaultValue={[min, max]}
      ref={rangeEl}
      allowCross={true}
      step={1}
      onAfterChange={validateChange}
    />
  );
};
PlazaRange.propTypes = {
  onChange: PropTypes.func.isRequired,
  dayMarks: PropTypes.any
};

export default PlazaRange;
